import { render, staticRenderFns } from "./emplacamento-nacional.vue?vue&type=template&id=3144ad2f&scoped=true&"
import script from "./emplacamento-nacional.vue?vue&type=script&lang=js&"
export * from "./emplacamento-nacional.vue?vue&type=script&lang=js&"
import style0 from "./emplacamento-nacional.vue?vue&type=style&index=0&id=3144ad2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144ad2f",
  null
  
)

export default component.exports